// extracted by mini-css-extract-plugin
export var measureBox = "_b7-0";